import React, { Component } from 'react';
import logo from './furnishedlivingla-logo-71618.png';
import fbLogoHeader from './FB-f-Logo__white_58.png'
import taLogoHeader from './ta-logo-rr-0.png'
import FaPhone from 'react-icons/lib/fa/phone';
import MdEmail from 'react-icons/lib/md/email';
import FaGoogle from 'react-icons/lib/fa/google';
import MdCopyright from 'react-icons/lib/md/copyright';
import MdOpenInNew from 'react-icons/lib/md/open-in-new';
import { Link } from 'react-router-dom';
import Center from './Center';
import FlexCenter from './FlexCenter';

class Footer2 extends Component {
  constructor(){
    super()
  }
  render(){

    return (
      <footer className="footer">
          {/* logo description social designer*/}
          <div className="footerLogoDescriptionContainer">
            <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                  <Link to ="/"><img id="logo-homepage2" className="white" src={logo} alt="Furnished Living Los Angeles"/></Link>
            </div>
            <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                <div className="footerSideDescriptionContainer">
                  <p className="footerDescription footerSideDescription">We offer luxury furnished apartments and corporate housing in Santa Monica and West Hollywood. We accept long-term stays only (31-day min). Units come furnished with complete kitchens, utilities, parking, central a/c, flat-screen TVs, full-cable, Netflix/Apple TV, and marble/tile bathroom floors.</p>
                </div>
            </div>
          </div>
          <div className="footerLogoDescriptionContainer2">
            <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
            </div>
            <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12">
              <div className="">
                
                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <div className="remove-padding">
                      <div className="footer-center-small flex-container flex-direction-col align-items-start">
                        <div className="footerNavItem footerColNavHeading">
                          Explore
                        </div>
                        <div className="footerNavItem">
                          <Link to={"/floor-plans"}>Floor Plans<div><span></span></div></Link>
                        </div>
                        <div className="footerNavItem">
                          <Link to={"/gallery"}>Gallery<div><span></span></div></Link>
                        </div>
                        <div className="footerNavItem">
                          <Link to={"/contact"}>Contact<div><span></span></div></Link>
                        </div>
                        <div className="footerNavItem">
                          <Link to={"/contact"}>For Residents<div><span></span></div></Link>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <div className="remove-padding">
                      <div className="footer-center-small flex-container flex-direction-col align-items-start">
                        <div className="footerNavItem footerColNavHeading">
                          Contact
                        </div>
                        <div className="footerNavItem footerPropertyContainer">
                          <div className="inline-block" onClick={() => document.getElementById('hidden-phone-number').click()}><h2>(424) 258-4690</h2>
                          </div>
                        </div>
                        <div className="footerNavItem footerPropertyContainer lowercase">
                          <div className="inline-block" onClick={() => document.getElementById('hidden-email').click()}><h2>info@furnishedlivingla.com</h2></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <div className="remove-padding">
                      <div className="footer-center-small flex-container flex-direction-col align-items-start">
                        <div className="footerNavItem footerColNavHeading">
                          Social
                        </div>
                        <div className="footerNavItem">
                          <a href="https://www.facebook.com/furnishedlivingla/" target="_blank">Facebook</a>
                        </div>
                        <div className="footerNavItem">
                          <a href="http://www.themls.com/Dashboards/sharedListings/umy8HDsQE6Z5fheGi8l-js4XZnaxeEOy0" target="_blank">The MLS</a>
                        </div>
                        <div className="footerNavItem">
                          <a href="https://goo.gl/maps/qhDqWKfUREs" target="_blank">Google +</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <div className="footer-col remove-padding">
                        <div className="footerNavItem footerColNavHeading">
                          Properties
                        </div>
                        <div className="flex-container flex-direction-col end-flex propertiesContainer">
                          <div className="footerPropertyContainer" onClick={() => window.open("https://goo.gl/maps/aYFbqKn9fHB2", "_blank")}>
                            <div className="center-address"><h2>135 Montana Ave</h2><MdOpenInNew className="openNewIconFont" /></div>
                            <div className="center-address"><h3>Santa Monica, CA 90403</h3></div>
                          </div>
                          <div className="footerPropertyContainer property2">
                            <div className="center-address" onClick={() => window.open("https://goo.gl/maps/1sxLai2LZtC2", "_blank")}><h2>435 Montana Ave</h2><MdOpenInNew className="openNewIconFont" /></div>
                            <div className="center-address"><h3>Santa Monica, CA 90403</h3></div>
                          </div>
                          <div className="footerPropertyContainer property2">
                            <div className="center-address" onClick={() => window.open("https://goo.gl/maps/NPZsMR44Mt22", "_blank")}><h2>8900 Rangely Ave</h2><MdOpenInNew className="openNewIconFont" /></div>
                            <div className="center-address"><h3>West Hollywood, CA 90048</h3></div>
                          </div>
                        </div>
                    </div>
                  </div>
                
              </div>
            </div>
          </div>
          <div className="termsFooterContainer">
            <div className="termsFooterInner">
              <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                <div className="add-padding">
                  <div className="bluePrintLogoContainer">
                    <MdCopyright className="copyrightIconFont" />
                      Site by Blueprint
                  </div>
                </div>
              </div>
              <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                <div className="add-padding">
                  
                    <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                        <div className="footer-center-small flex-container flex-direction-col align-items-start">
                          <div className="footerNavItem footerColNavHeading termsHeading">
                            Terms & Conditions
                          </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                      
                        <div className="footer-center-small flex-container flex-direction-col align-items-start">
                          <div className="footerNavItem footerColNavHeading termsHeading">
                            Privacy Policy
                          </div>
                        </div>
                      
                    </div>
                  
                </div>
              </div>
            </div>
            
          </div>

          
      </footer>
    )
  }
}

export default Footer2;



// WEBPACK FOOTER //
// ./src/Footer2.js